import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8001/api';

const LogoOrganizacion = ({ className = "h-12 w-auto" }) => {
  const [config, setConfig] = useState(null);
  const [logoUrl, setLogoUrl] = useState(null);

  useEffect(() => {
    cargarConfiguracion();
  }, []);

  const cargarConfiguracion = async () => {
    try {
      const response = await axios.get(`${API_URL}/configuracion/organizacion`);
      
      if (response.data.success) {
        const configData = response.data.data;
        setConfig(configData);
        
        // Si hay logo y está habilitado, cargar la URL
        if (configData.logo_filename && configData.mostrar_logo) {
          setLogoUrl(`${API_URL}/configuracion/organizacion/logo?t=${Date.now()}`);
        }
      }
    } catch (error) {
      console.error('Error al cargar configuración:', error);
    }
  };

  // Si no hay logo, mostrar el nombre de la organización o título por defecto
  if (!logoUrl || !config?.mostrar_logo) {
    return (
      <div className="flex items-center">
        <h1 className="text-xl font-bold text-gray-900">
          {config?.nombre_organizacion || 'Sistema de Evaluación 360°'}
        </h1>
      </div>
    );
  }

  return (
    <div className="flex items-center space-x-3">
      <img
        src={logoUrl}
        alt={config?.nombre_organizacion || 'Logo'}
        className={className}
        onError={(e) => {
          // Si falla la carga, ocultar la imagen
          e.target.style.display = 'none';
        }}
      />
      {config?.nombre_organizacion && (
        <span className="text-lg font-semibold text-gray-900 hidden sm:block">
          {config.nombre_organizacion}
        </span>
      )}
    </div>
  );
};

export default LogoOrganizacion;
